import { isLiteralObject } from './object';
export function asIconData(v) {
    return isIconComponentProps(v) ? v.data : v;
}
function isIconComponentProps(v) {
    // `iconName` is a required property of `IconDefinition`, the only other object that `IconInput` supports.
    // If it is undefined, then only ComponentProps<Icon> is viable.
    return isLiteralObject(v) && typeof v['iconName'] === 'undefined';
}
